import { Component, OnInit } from '@angular/core';
import { CompanyLookupResult } from '@shared/models/data-model';
import { CompanySearchService } from '@shared/services/company-search.service';
import { ModalDialogService } from '@shared/services/modal-dialog.service';
import moment from 'moment-mini';

@Component({
    selector: 'company-search-detail-modal',
    templateUrl: './company-search-detail-modal.component.html',
    styleUrls: ['./company-search-detail-modal.component.scss']
})
export class CompanySearchDetailModalComponent implements OnInit {
    result: CompanyLookupResult;
    dateOfIncorporation: string;

    constructor(
        private readonly companySearchService: CompanySearchService,
        private readonly modalDialogService: ModalDialogService
    ) {}

    ngOnInit() {
        this.result = this.companySearchService.getCachedLookupResult();
        const date = moment(this.result.dateOfIncorporation, 'YYYY-MM-DD')
        if(date.isValid()) {
            this.dateOfIncorporation = date.format('DD/MM/YYYY');
        }
    }

    confirm() {
        this.modalDialogService.closeModalDialog(true);
    }

    dismiss() {
        this.modalDialogService.closeModalDialog();
    }
}
